<script setup lang="ts"></script>

<template>
  <div>FORBIDDEN</div>
</template>

<style></style>
